import { forwardRef } from "react";
import SceneFrame from "./SceneFrame";
import { getSceneImageProps } from "../sceneAssets";

const Scene7 = forwardRef(function Scene7({ copy, language, isArabic, breakpoint = "desktop" }, ref) {
  const { imageSrc, imageSrcSet, imageSizes } = getSceneImageProps(7, breakpoint);
  return (
    <SceneFrame
      ref={ref}
      sceneId={7}
      imageSrc={imageSrc}
      imageSrcSet={imageSrcSet}
      imageSizes={imageSizes}
      copy={copy}
      language={language}
      isArabic={isArabic}
    />
  );
});

export default Scene7;
